import React, { useMemo } from "react";
import Capabilities from "../Capabilities";
import { normalizeRfiServicesFieldToLabels } from "../../utils/myRfiGridRowMapper";
import { resolveServiceCategoryNameFromLabel } from "../../utils/templateToServiceCategory";
import { DEFAULT_GRAY_RFI_BADGE_STYLE } from "../../utils/rfiCatalogServiceNames";

export default function RfiTemplateServiceBadges({
  services,
  fallbackTemplateName,
  badgesPerRow = 3,
}) {
  const serviceLabels = useMemo(() => {
    const labels = normalizeRfiServicesFieldToLabels(services);
    const source =
      labels.length > 0
        ? labels
        : normalizeRfiServicesFieldToLabels(fallbackTemplateName);

    return source.map(
      (label) => resolveServiceCategoryNameFromLabel(label) || label
    );
  }, [services, fallbackTemplateName]);

  if (serviceLabels.length === 0) {
    return <span className="text-xs text-gray-400">--</span>;
  }

  return (
    <Capabilities
      services={serviceLabels}
      icon={true}
      showLimited={false}
      badgesPerRow={badgesPerRow}
      applyRfiCatalogCustomLabels={true}
      stripNewSuffixFromDisplay={true}
      fallbackBadgeStyle={DEFAULT_GRAY_RFI_BADGE_STYLE}
    />
  );
}
